

















import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
    name: "CollectionFilter",
    props: {
        collection: {
            type: Object,
            required: true
        },
        activeCollectionId: {
            type: Number,
            default: null
        }
    },
    setup(props, { emit }) {
        /**
         * check if this collection is selected
         */
        var isSelected = computed(() => {
            return props.activeCollectionId == props.collection?.collection_id;
        });

        /**
         * handle the collection changed click event
         */
        const handleCollectionChanged = (collectionId: number) => {
            emit("collection-clicked", collectionId);
        };

        return {
            props,
            isSelected,
            handleCollectionChanged
        };
    }
});
